<template>
  <div class="home_container">
    <h1 class="home_title">
      <span>B</span>
      <span>r</span>
      <span>o.</span>
      <span>M</span>
      <span>u</span>
      <span>s</span>
      <span>i</span>
      <span>c</span>
    </h1>

    <router-link class="homeRouter" to="/track">
      <h2 class="home_open">
        <span>O</span>
        <span>p</span>
        <span>e</span>
        <span>n</span>
      </h2>
    </router-link>
  </div>
</template>

<script>
export default {};
</script>

<style>
@import url("../assets/home.css");
@import url("../assets/home_RWD.css");
</style>